import { useTranslation } from 'react-i18next';
import { Box, Button, Stack, Typography } from '@mui/material';

import { useCallsMenu } from '../../CallsMenuContext';

import { dialButtonStyles, dialpadContainerStyles, dialpadGridStyles } from './styles';

interface DialpadSectionProps {
  stageDial?: string;
}

const dialpadButtons = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '*', '#'];

export const DialpadSection = ({ stageDial }: DialpadSectionProps) => {
  const { t } = useTranslation();
  const { selectedStageId, getParentStageDialOptions, onStageChange } = useCallsMenu();

  const dialOptions = getParentStageDialOptions(selectedStageId!);

  const handleDialpadClick = (button: string) => () => {
    onStageChange(selectedStageId!, { dialOption: button });
  };

  return (
    <>
      <Stack display="flex" flexDirection="column" gap={3}>
        <Typography variant="subtitle2">{t('callsMenu.selectedStage.dialpad')}</Typography>
        <Box sx={dialpadContainerStyles}>
          <Box sx={dialpadGridStyles}>
            {dialpadButtons.map((button) => (
              <Button
                key={button}
                variant="contained"
                disabled={dialOptions.has(button) && button !== stageDial}
                color={button === stageDial ? 'secondary' : 'primary'}
                sx={dialButtonStyles}
                onClick={handleDialpadClick(button)}
              >
                {button}
              </Button>
            ))}
          </Box>
        </Box>
      </Stack>
    </>
  );
};
